import api from './api';

export const getCountries = async () => {
  try {
    const response = await api.get('/countries');
    return response;
  } catch (error) {
    throw error;
  }
};
